<ng-container>
	<header class="data-table__create-section">
		<div class="search-field">
			<div class="search-icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19">
					<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="1.5" transform="translate(1 1)">
						<circle cx="7" cy="7" r="7"/>
						<path stroke-linecap="square" d="M13.5 12.5L18 17"/>
					</g>
				</svg>
			</div>
			<input type="text" name="search" (keyup)="onSearch.emit($event.target.value)" i18n-placeholder="@@input.search_here" placeholder="Search" #searchInput>
		</div>
	</header>

	<div class="data-table__filter">
		<div class="top-filter">
			<div class="left-section">
				
			</div>
			<!-- <div class="right-section">
				<a href="javascript:void(0);" class="filter-button" (click)="toggleFilter()">
					<span i18n="@@common.filter">Filter</span>
					<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
						<g fill="none" fill-rule="evenodd">
							<g fill="#00C2CF" stroke="#00C2CF" stroke-width=".5">
								<path d="M18.485 2.5H2.447c-.376 0-.68.29-.68.647 0 1.803.811 3.523 2.226 4.721l2.976 2.52c.516.436.812 1.064.812 1.722v6.312c0 .515.606.825 1.057.538l4.01-2.546c.188-.12.302-.322.302-.538V12.11c0-.658.296-1.286.812-1.723l2.976-2.519c1.415-1.198 2.226-2.918 2.226-4.72 0-.358-.304-.648-.68-.648zm-2.45 4.4L13.06 9.42c-.806.682-1.268 1.663-1.268 2.69v3.42l-2.65 1.682V12.11c0-1.027-.463-2.008-1.269-2.69L4.896 6.9c-.954-.807-1.563-1.914-1.726-3.106h14.591c-.163 1.192-.772 2.299-1.726 3.106z" transform="translate(-1295 -425) translate(1219 410) translate(76 15)"/>
							</g>
						</g>
					</svg>
				</a>
			</div> -->
		</div>
		<!-- <div class="body-filter" [class.show]="isFilter">
			<fieldset class="date sl">
				<label i18n="@@common.from_date">From Date</label>
				<div class="date-input-wrap">
					<input type="text" date-dropper [(ngModel)]="fromDate" (onDatePicked)="filterByDate()" i18n-placeholder="@@common.from_date" placeholder="From Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="invoice-date-range" />
				</div>
			</fieldset>
			<fieldset class="date sl">
				<label i18n="@@common.to_date">To Date</label>
				<div class="date-input-wrap">
					<input type="text" date-dropper [(ngModel)]="toDate" (onDatePicked)="filterByDate()" i18n-placeholder="@@common.to_date" placeholder="To Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="invoice-date-range" />
				</div>
			</fieldset>
			<fieldset class="md">
				<label i18n="@@common.status">Status</label>
				<select nice-select i18n-data-placeholder="@@option.select_status" data-placeholder="Select Status" class="nice-select" [(ngModel)]="invoice_status" (change)="filterByStatus()">
					<option value="" i18n="@@option.select_status">Select Status</option>

					<option value="successful" *ngIf="activeTab == 'received-payments'" i18n="@@ts.successful">Successful</option>

					<option value="pending" i18n="@@ts.pending" *ngIf="activeTab == 'pending-payments'">Pending</option>
					<option value="rejected" i18n="@@ts.rejected" *ngIf="activeTab == 'pending-payments'">Rejected</option>
				</select>
			</fieldset>
			<fieldset class="md">
				<label i18n="@@common.minimum_amount">Minimum amount</label>
				<div class="tag-input">
					<input type="text" [(ngModel)]="minAmount" (keyup)="filterByAmount()" placeholder="100"/>
					<span>{{ userInfo?.currency_symbol }}</span>
				</div>
			</fieldset>
			<fieldset class="md">
				<label i18n="@@common.maximum_amount">Maximum amount</label>
				<div class="tag-input">
					<input type="text" [(ngModel)]="maxAmount" (keyup)="filterByAmount()" placeholder="10,000"/>
					<span>{{ userInfo?.currency_symbol }}</span>
				</div>
			</fieldset>
		</div> -->
	</div>
</ng-container>